export const EXCMCASE_DELETE_RESET = 'EXCMCASE_DELETE_RESET'
export const EXCMCASE_DELETE_SET_ERROR = 'EXCMCASE_DELETE_SET_ERROR'
export const EXCMCASE_DELETE_SET_DELETED = 'EXCMCASE_DELETE_SET_DELETED'
export const EXCMCASE_DELETE_TOGGLE_LOADING = 'EXCMCASE_DELETE_TOGGLE_LOADING'
